import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

import LogoImage from '../../../../assets/images/logo.png';
import TextField from '../../../Common/TextField';
import { authActions } from '../../store';
import styles from './SignIn.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../routes/constants';
import useWindowSize from '../../../../utils/useWindowSize';
import clsx from 'clsx';
import LanguageSelector from '../../../Common/LanguageSelector';
import { sendMessageToApp } from 'utils/exsternalCall';

const fieldProps = {
  component: TextField,
  height: '50px',
  margin: '0 0 16px 0',
};

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const fromApp = !!localStorage.getItem('fromApp');
  const { isMobile } = useWindowSize();
  const initialValues = {
    email: '',
    pwd: '',
  };
  const validationSchema = {
    email: yup
      .string(t('common.validation.email.string'))
      .email(t('common.validation.email.valid'))
      .required(t('common.validation.email.required')),
    pwd: yup
      .string()
      .min(3, t('common.validation.password.short'))
      .max(100, t('common.validation.password.long'))
      .required(t('common.validation.password.required')),
  };

  const openTypeform = () => {
    const url = 'https://v0-zeta-barber-back-office-wi.vercel.app/f/d32cab3833c4eb44d7ee5db2?source=app-business';
    if (!fromApp) window.open(url, '_blank');
    else sendMessageToApp('app:url', { url });
  };

  const openTerms = () => {
    const termsLink =
      'https://general-store-s3.s3.eu-south-1.amazonaws.com/zetabarber/nuovi+Termini+e+condizioni+generali+di+servizio.html';
    if (!fromApp) window.open(termsLink, '_blank');
    else sendMessageToApp('app:url', { url: termsLink });
  };

  const openPrivacy = () => {
    const privacyLink =
      'https://general-store-s3.s3.eu-south-1.amazonaws.com/zetabarber/Informativa+sul+trattamento+dei+dati+personali+e+cookie+policy+Zetabarber.html';
    if (!fromApp) window.open(privacyLink, '_blank');
    else sendMessageToApp('app:url', { url: privacyLink });
  };

  return (
    <div
      className={clsx(styles.container__inner, {
        [styles.container__inner__mobile]: isMobile,
      })}
    >
      <div className={styles.languageSelector}>
        <LanguageSelector />
      </div>
      <div className={styles['login__container']}>
        <img src={LogoImage} alt={t('common.logo')} className={styles.logo} />
        <h1>
          {t('auth.signin.welcome')} {isMobile && <br />}
          <span>{t('auth.signin.barber')}</span>
        </h1>
        <p className={styles.lead}>{t('auth.signin.description')}</p>
        <Formik
          initialValues={initialValues}
          validationSchema={yup.object().shape(validationSchema)}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={(values) => dispatch(authActions.SIGN_IN.REQUEST(values))}
        >
          {() => (
            <Form className={styles['login__form']}>
              <Field
                {...fieldProps}
                name='email'
                id='email'
                label={t('common.form.email.label')}
                placeholder={t('common.form.email.placeholder')}
                type='email'
                autoComplete='username'
                showIcon={true}
              />
              <Field
                {...fieldProps}
                name='pwd'
                id='pwd'
                label={t('common.form.password.label')}
                placeholder={t('common.form.password.placeholder')}
                showPassword={true}
                showIcon={true}
                type='password'
                autoComplete='current-password'
              />

              <button type='submit' className={styles.confirm_button}>
                {t('auth.signin.submit')}
              </button>
            </Form>
          )}
        </Formik>
        <button
          type='button'
          className={styles.pwdRecovery}
          onClick={() => navigate(ROUTES.RECOVERY)}
        >
          {t('auth.signin.forgotPassword.text')} {t('auth.signin.forgotPassword.link')}
        </button>
        <div className={styles.divider}>
          <span>{t('auth.signin.or')}</span>
        </div>
        <button type='button' className={styles.secondary_button} onClick={openTypeform}>
          {t('auth.signin.requestAccount')}
        </button>
        <p className={styles.footer}>
          {t('common.terms.acceptance')}{' '}
          <button type='button' className={styles.footer_link} onClick={openTerms}>
            {t('common.terms.terms')}
          </button>{' '}
          {t('common.terms.and')}{' '}
          <button type='button' className={styles.footer_link} onClick={openPrivacy}>
            {t('common.terms.privacy')}
          </button>{' '}
          {t('common.terms.of')} {t('common.zetabarber')}
        </p>
      </div>
    </div>
  );
};
